import React from 'react'
import { Stack } from 'react-bootstrap'
import { LanguageTooltip } from './LanguageTooltip'
import { MeetingLanguage } from '../../models/Room'
import { getLanguageLabel } from '../../common/languageUtils'
import { Button } from '../../components/Button/Button'

export interface LanguageButtonProps {
  language: MeetingLanguage | null
  tooltipText?: string
  onLanguageClick?: () => void
  isCalculated: boolean
}

export const LanguageButton: React.FC<LanguageButtonProps> = ({ language, tooltipText, onLanguageClick, isCalculated }) => {
  const languageLabel = getLanguageLabel(language)
  if (!languageLabel) {
    return null
  }

  return (
    <LanguageTooltip tooltipText={tooltipText}>
      <Button className='px-2 py-1' variant='grayButton' onClick={onLanguageClick}>
        <Stack direction='horizontal' gap={1}>
          <i className='text-black bi bi-globe2' />
          <span className='paragraph-small'>{languageLabel}</span>
          {isCalculated ? <i className='zocks-text-warning-light bi bi-circle-fill' style={{ fontSize: '0.5rem' }} /> : null}
        </Stack>
      </Button>
    </LanguageTooltip>
  )
}
